import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }

import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import { collectionPatch } from "@/common/api/rest/collection";
import { avatarAdd, avatarPut, avatarDel } from "@/common/api/rest/avatar";

import type { CollectionType } from "@/common/types/collection";
import type { TranslationFieldsType } from "@/common/types/translation";

import { FormCollection, ListTranslate } from "@/components";

import { baseAvatar, baseConfirm } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'infos',
  props: {
    collection: {},
    collectionId: {}
  },
  emits: ["update:data"],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n();
const route = useRoute();

const emit = __emit;

const props = __props;

const showAvatarDel = ref(false);

const translationFields = ref<TranslationFieldsType[]>([
  {
    type: "input",
    field: "name",
    label: "common.labels.name",
    value: "",
  },
  {
    type: "textarea",
    field: "description",
    label: "common.labels.description",
    value: "",
  },
]);

function patchData(payload: Partial<CollectionType>) {
  collectionPatch(props.collectionId, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        // emit("update:data");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

const type = computed(() => route.params.type as string);

// AVATAR
function addAvatar(avatar: string) {
  if (!store.getters.user) return;

  store.commit("SET_LOADING", true);

  avatarAdd(props.collection.collection_id, avatar)
    .then((response) => {
      const { success, message } = response;

      toast({ message: message, type: success ? "success" : "error" });

      emit("update:data");
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function updateAvatar(avatar: string) {
  if (!props.collection.avatar) return;

  store.commit("SET_LOADING", true);

  avatarPut(props.collection.collection_id, avatar)
    .then((response) => {
      const { success, message } = response;

      toast({ message: message, type: success ? "success" : "error" });

      emit("update:data");
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function changeAvatar(avatar: string) {
  if (props.collection.avatar) {
    updateAvatar(avatar);
  } else {
    addAvatar(avatar);
  }
}

function delAvatar() {
  showAvatarDel.value = true;
}

function delAvatarConfirm() {
  if (!props.collection?.avatar) return;

  store.commit("SET_LOADING", true);

  avatarDel(props.collection.collection_id)
    .then((response) => {
      const { success, message } = response;

      toast({ message: message, type: success ? "success" : "error" });

      emit("update:data");
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      showAvatarDel.value = false;
      store.commit("SET_LOADING", false);
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(baseAvatar), {
        position: "center",
        size: "20rem",
        "is-edit": true,
        "show-image": true,
        url: __props.collection?.avatar?.large,
        "aspect-ratio": 1,
        "border-radius": "0.25rem",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (changeAvatar($event))),
        onDel: _cache[1] || (_cache[1] = ($event: any) => (delAvatar()))
      }, null, 8, ["url"])
    ]),
    _createVNode(_unref(FormCollection), {
      data: __props.collection,
      type: type.value,
      "is-patch": true,
      "onUpdate:data": _cache[2] || (_cache[2] = ($event: any) => (patchData($event)))
    }, null, 8, ["data", "type"]),
    _createVNode(_unref(ListTranslate), {
      "owner-id": __props.collectionId,
      language: _unref(locale).toLowerCase(),
      fields: translationFields.value
    }, null, 8, ["owner-id", "language", "fields"]),
    _createVNode(_unref(baseConfirm), {
      show: showAvatarDel.value,
      title: _unref(t)('common.modals.titles.remove_image').toUpperCase(),
      message: _unref(t)('common.modals.messages.remove_image'),
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (showAvatarDel.value = false)),
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (delAvatarConfirm()))
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})